const TOKEN_KEY = 'qe_token';
const TOKEN_MODE_KEY = 'qe_token_mode';

type TokenMode = 'local' | 'session';

function getPreferredStorage(mode: TokenMode): Storage {
  return mode === 'session' ? window.sessionStorage : window.localStorage;
}

export function getStoredToken(): string | null {
  return window.localStorage.getItem(TOKEN_KEY) ?? window.sessionStorage.getItem(TOKEN_KEY);
}

export function saveStoredToken(token: string, rememberMe = true): void {
  const mode: TokenMode = rememberMe ? 'local' : 'session';
  window.localStorage.removeItem(TOKEN_KEY);
  window.sessionStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(TOKEN_MODE_KEY);
  window.sessionStorage.removeItem(TOKEN_MODE_KEY);
  getPreferredStorage(mode).setItem(TOKEN_KEY, token);
  getPreferredStorage(mode).setItem(TOKEN_MODE_KEY, mode);
}

export function clearStoredToken(): void {
  window.localStorage.removeItem(TOKEN_KEY);
  window.sessionStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(TOKEN_MODE_KEY);
  window.sessionStorage.removeItem(TOKEN_MODE_KEY);
}
